// extracted by mini-css-extract-plugin
module.exports = {"link":"N2xDI","root":"ec6C8","label":"_3LeVF"};